export default {
  linkedinAuth: {},
};
